module.exports = __webpack_public_path__ + "static/preowned-cd4aa3e3f4cfac8d8b60d54a9e363744.png";